import { Field, Int } from '@nestjs/graphql'
import { BaseModelWithoutUserDto } from '../base/baseModelWithoutUser.dto'
import { ObjectType } from '@nestjs/graphql'
import { CategoryTranslationDto } from './translation.dto'

@ObjectType()
export class CategoryDto extends BaseModelWithoutUserDto {
  /** Always the English source of truth. Localised names live in `translations`. */
  @Field()
  name!: string

  @Field(t => Int)
  sortOrder!: number

  @Field(t => Int, { nullable: true })
  parentCategoryId?: number | null

  @Field(t => CategoryDto, { nullable: true })
  parentCategory?: CategoryDto

  @Field(t => [CategoryDto], { nullable: true })
  childCategories?: CategoryDto[]

  @Field(t => [CategoryTranslationDto], { nullable: true })
  translations?: CategoryTranslationDto[]
}
